import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import SimpleBar from "simplebar-react"

const ModalResults = ({ details, showModal, setShowModal, onClose }) => {
  return (
    <Modal
      isOpen={showModal}
      toggle={() => {
        setShowModal(!showModal)
      }}
      size="lg"
      centered
      onClose={() => {
        onClose()
      }}
    >
      <ModalHeader>
        Resultado da Execução
        <button
          type="button"
          onClick={() => {
            setShowModal(false)
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <SimpleBar style={{ height: "80vh" }}>
        <ModalBody>
          <pre>{JSON.stringify(details, null, 2)}</pre>
        </ModalBody>
      </SimpleBar>
    </Modal>
  )
}

ModalResults.propTypes = {
  details: PropTypes.array,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  onClose: PropTypes.func,
}

export default ModalResults
